import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SEO from '../components/SEO';
import AdUnit from '../components/AdUnit';
import ScrollReveal from '../components/ScrollReveal';
import API_BASE_URL from '../config';

var LIMIT = 8;

function Learn() {
  var [searchParams, setSearchParams] = useSearchParams();
  var page = Number(searchParams.get('page')) || 1;
  var [guides, setGuides] = useState([]);
  var [loading, setLoading] = useState(true);
  var [totalPages, setTotalPages] = useState(1);

  function setPage(p) {
    setSearchParams(p > 1 ? { page: p } : {}, { replace: false });
  }

  useEffect(function () {
    setLoading(true);
    fetch(API_BASE_URL + '/api/guides?page=' + page + '&limit=' + LIMIT)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setGuides(data.guides || []);
        setTotalPages(data.pagination ? data.pagination.totalPages : 1);
        setLoading(false);
      })
      .catch(function () { setLoading(false); });
  }, [page]);

  return (
    <div className="page-home">
      <SEO title="Learn — AI, LLMs, RAG, MCP & Developer Guides" description="In-depth guides on AI, Large Language Models, RAG pipelines, MCP servers, AI agents, and practical developer topics. Written for builders." path="/learn" />

      <section className="home-hero" style={{ paddingBottom: 'var(--space-6)' }}>
        <div className="container">
          <ScrollReveal>
            <h1 className="home-hero-title">Learn</h1>
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <p className="home-hero-sub">In-depth guides on AI, LLMs, and developer topics. Written for builders, not buzzword chasers.</p>
          </ScrollReveal>
        </div>
      </section>

      <section className="home-section home-section--tinted">
        <div className="container">
          {loading && <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Loading guides…</p>}
          <div className="home-card-stack">
            {guides.map(function (g, i) {
              var items = [];
              items.push(
                <ScrollReveal key={g.slug} delay={i * 40}>
                  <Link to={'/learn/' + g.slug} className="home-wide-card">
                    <div>
                      <h3 className="home-wide-card-title">{g.title}</h3>
                      <div className="home-wide-card-meta">
                        <span className="article-tag">{g.tag}</span>
                        <span className="home-wide-card-read-time">{g.readTime || g.read_time}</span>
                      </div>
                    </div>
                    <div className="home-wide-card-body">
                      <p className="home-wide-card-desc">{g.excerpt}</p>
                      <span className="home-wide-card-link">Read guide →</span>
                    </div>
                  </Link>
                </ScrollReveal>
              );
              if (i === 0 && page === 1) items.push(<AdUnit key="ad-after-first" />);
              return items;
            })}
          </div>

          {totalPages > 1 && (
            <div className="home-pagination">
              <button
                className="btn btn-secondary"
                disabled={page <= 1}
                onClick={function () { setPage(page - 1); window.scrollTo(0, 0); }}
                type="button"
              >← Previous</button>
              <span className="home-pagination-info">Page {page} of {totalPages}</span>
              <button
                className="btn btn-secondary"
                disabled={page >= totalPages}
                onClick={function () { setPage(page + 1); window.scrollTo(0, 0); }}
                type="button"
              >Next →</button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Learn;
